module.exports = __webpack_public_path__ + "img/robot_1.9732af95.png";